import { render, staticRenderFns } from "./AuthorityGroupMemberListPopup.vue?vue&type=template&id=2c2b2939&"
import script from "./AuthorityGroupMemberListPopup.vue?vue&type=script&lang=ts&"
export * from "./AuthorityGroupMemberListPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports